import {ILookupEntry} from 'shared/types/lookups';
import {performRequest} from 'shared/utils';

import {IExternalSystemUserMappingDto} from './external-systems-slice-types';

export interface IGetExternalSystemsForUserArgs {
    userId: number;
}

export const getExternalSystemsForUser = ({
    userId,
}: IGetExternalSystemsForUserArgs) => performRequest<IExternalSystemUserMappingDto[]>({
    url: 'external-systems/getExternalSystemsForUser',
    params: {
        userId,
    },
});

export interface IGetAvailableExternalSystemsForUserArgs {
    userId: number;
}

export const getAvailableExternalSystemsForUser = ({
    userId,
}: IGetAvailableExternalSystemsForUserArgs) => performRequest<ILookupEntry[]>({
    url: 'external-systems/getAvailableExternalSystemsForUser',
    params: {
        userId,
    },
});

export interface IPostExternalSystemsForUserArgs {
    userId: number;
    data: Omit<Partial<IExternalSystemUserMappingDto>, 'externalMappingId'>[];
}

export const postExternalSystemsForUser = ({
    data,
    userId,
}: IPostExternalSystemsForUserArgs) => performRequest({
    url: `external-systems/save/${userId}`,
    data,
    method: 'POST',
});

export const getUseExternalSystemsPropertyFlag = () => performRequest<'Y' | 'N'>({
    url: '/property/USE_FLEX_VALUE_SET_DIRECTORY_OF_EXTERNAL_SYSTEMS',
    method: 'GET',
});
